import React from "react";
import { ClientApartment } from "../../../utils/api/apartmentRentalsAPI";

interface Props {
  apt: ClientApartment;
  daysUntilCheckIn: number | null;
}

const PromoBanners: React.FC<Props> = ({ apt, daysUntilCheckIn }) => {
  const lm = apt.lastMinute;
  const eb = apt.earlyBooking;
  if (!lm?.enabled && !eb?.enabled) return null;

  const lmActive = lm?.enabled && daysUntilCheckIn !== null && daysUntilCheckIn >= 0 && daysUntilCheckIn <= lm.daysThreshold;
  const ebActive = eb?.enabled && daysUntilCheckIn !== null && daysUntilCheckIn >= eb.daysThreshold;

  return (
    <div className="pab-promo-strip">
      {lm?.enabled && (
        <div className={`pab-promo-banner${lmActive ? " pab-promo-banner--active" : " pab-promo-banner--dim"}`}>
          <div className="pab-promo-banner__icon">⚡</div>
          <div className="pab-promo-banner__body">
            <div className="pab-promo-banner__title">
              Last Minute{lmActive ? " — popust aktivan!" : " ponuda"}
            </div>
            <div className="pab-promo-banner__desc">
              Rezerviši unutar <strong>{lm.daysThreshold} {lm.daysThreshold === 1 ? "dana" : "dana"}</strong> od dolaska i uštedi <strong>{lm.discount}%</strong>
              {lmActive && daysUntilCheckIn !== null && (
                <span className="pab-promo-banner__countdown">Ostalo: {daysUntilCheckIn} {daysUntilCheckIn === 1 ? "dan" : "dana"}</span>
              )}
            </div>
          </div>
          <div className="pab-promo-banner__pct">−{lm.discount}%</div>
        </div>
      )}
      {eb?.enabled && (
        <div className={`pab-promo-banner${ebActive ? " pab-promo-banner--active" : " pab-promo-banner--dim"}`}>
          <div className="pab-promo-banner__icon">🗓</div>
          <div className="pab-promo-banner__body">
            <div className="pab-promo-banner__title">
              Early Booking{ebActive ? " — popust aktivan!" : " popust"}
            </div>
            <div className="pab-promo-banner__desc">
              Rezerviši <strong>{eb.daysThreshold}+ dana</strong> unaprijed i uštedi <strong>{eb.discount}%</strong>
              {ebActive && daysUntilCheckIn !== null && (
                <span className="pab-promo-banner__countdown">{daysUntilCheckIn} dana do dolaska ✓</span>
              )}
            </div>
          </div>
          <div className="pab-promo-banner__pct">−{eb.discount}%</div>
        </div>
      )}
    </div>
  );
};

export default PromoBanners;
